module.exports = __webpack_public_path__ + "fonts/MyriadPro-Regular.5ff10d55.eot";